import SwiperCore, { Pagination, A11y, Navigation, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import Icon from 'common/Icon'
import Image from 'next/image'
import styles from './index.module.scss'

import { SILVER_SAND } from 'constants/colors'

SwiperCore.use([Pagination, A11y, Navigation, Autoplay])

const HowItWorksCarousel: React.FC<HowItWorksProps> = ({
  HowItWorksCarouselData,
}) => (
  <div className={styles.howItWorksCarousel}>
    <Swiper
      slidesPerView={1}
      autoplay={{ delay: 15000, disableOnInteraction: false }}
      pagination={{
        clickable: false,
        bulletClass: 'carousel-custom-pagination-bullet',
        el: '.carousel-swiper-pagination',
      }}
      navigation={{
        prevEl: '.carousel-swipe-to-prev',
        nextEl: '.carousel-swipe-to-next',
      }}
      observer
      className="how-it-works-carousel-wrapper"
      loop
    >
      {HowItWorksCarouselData.map((slide) => (
        <SwiperSlide key={slide.id}>
          <div className={styles.howItWorksCarousel__container}>
            <div className={styles.howItWorksCarousel__imageWrapper}>
              <Image
                src={slide.image}
                width={576}
                height={496}
                alt="How it works"
                priority
              />
            </div>
            <div className={styles.howItWorksCarousel__content}>
              <h2 className={styles.howItWorksCarousel__heading}>
                {slide.heading}
              </h2>
              <div className={styles.howItWorksCarousel__description}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: slide.description,
                  }}
                />
              </div>
              <div className={styles.howItWorksCarousel__slideNavigation}>
                <div className="carousel-swipe-to-prev">
                  <Icon
                    icon="datePrevArrow"
                    fill={SILVER_SAND}
                    className="fa-lg"
                  />
                </div>
                <div className="carousel-swiper-pagination"></div>
                <div className="carousel-swipe-to-next">
                  <Icon
                    icon="dateNextArrow"
                    fill={SILVER_SAND}
                    className="fa-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
)

export default HowItWorksCarousel
